import React from 'react'
import RegionComponent from '../Region/RegionComponent'

type RegionsComponentTypes = {
  regions: any[]
}

const RegionsComponent = ({ regions, ...rest }: RegionsComponentTypes) => {
  return (
    <>
      {regions &&
        regions.map((region: any, index: number) => (
          <React.Fragment key={`region-${region.id}-${index}`}>
            <RegionComponent region={region} {...rest} />
          </React.Fragment>
        ))}
    </>
  )
}

export default RegionsComponent
